module.exports = __webpack_public_path__ + "static/media/stats-icon-1.9f1d45ac.svg";